const gamesFa = {
  gameCryptoWar: "kripto savaşları",
  gameSoccer: "Futbol",
};

export default gamesFa;
